import script from "./TrocarPlano.vue?vue&type=script&setup=true&lang=js"
export * from "./TrocarPlano.vue?vue&type=script&setup=true&lang=js"

import "./TrocarPlano.vue?vue&type=style&index=0&id=6cd71a23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd71a23"]])

export default __exports__